/* eslint-disable react-hooks/exhaustive-deps */

import { Box } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';

import AuthorizationDetails from './authorizationDetails.component';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';

import { setPageTitle, showToast } from 'modules/layout/layout.actions';

import {
  getAuthorizationSummary,
  setAuthId,
  setLoadingComplete,
  getAuthClientPoliciesListByClient,
  updateAuthorizationSummary,
  getAuthorizationComments,
  getTasksByFileId,
  createFileTask,
  postAuthorizationComment
} from '../store/actions/authorizations.actions';

import { getTemporaryLivingAssignments } from '../store/actions/temporaryLiving.actions';
import { getGlobalInfo } from '../store/actions/global.actions';
import { getTaskComments, updateTask } from 'modules/dashboard/dashboard.actions';

import { getSurveyQuestionResponsesByAuth } from 'modules/surveys/surveys.actions';

import { getVendors } from '../store/actions/dataManagement.actions';
import { getCommentsAndNotes } from '../store/actions/commentsAndNotes.actions';
import {
  fetchAuthDetails,
  fetchVendors,
  fetchEnumerations,
  fetchCommentsAndNotes,
  fetchFileTasks
} from '../utils/fetchDataDetailsService';

import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getInternalUsers } from 'modules/common/common.actions';
import { getEmailTemplateSummaries } from 'modules/emailTemplates/store/emailTemplate.actions';
import { getClientDetails, setClientId } from 'modules/clients/clients.actions';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const AuthorizationDetailsView = props => {
  const details = props.authorizationDetails ? props.authorizationDetails[props.match.params.id] : null;

  useEffect(() => {
    props.setPageTitle('Authorization Details');

    async function fetchData() {
      const id = props.match.params.id;
      props.setAuthId(id);

      await fetchEnumerations(props);
      const authSummary = await fetchAuthDetails(details, id, props);
      if (authSummary?.services?.some(service =>
        service.isEnabled && service.authorizationFileServiceTypeId?.toLowerCase() === 'e5c3355e-9171-4968-a142-1a9d643a4b7d'
      )) {
        await props.getGlobalInfo(id);
      }
      await fetchCommentsAndNotes(details, id, props);
      await fetchFileTasks(details, id, props);
      await fetchVendors(props?.vendors, props);
      await fetchEnumerations(props);
      await props.getInternalUsers();
      if (!props.templates || props.templates.isLoaded === false) {
        await props.getEmailTemplateSummaries();
      }
      props.setLoadingComplete();
    }

    fetchData();
  }, []);

  const resetSurveyApiCall = async () => {
    let request = details?.authDetails?.summary;
    if (request) {
      request.surveySent = false;
      await props.updateAuthorizationSummary(request);
    }
  };

  return (
    <Box>
      {!props.isLoading && details && details.authorizationDetails && props.enumerations.allEnums && props.clientsInfo[details.authorizationDetails.clientId] && (
        <AuthorizationDetails
          classes={props.classes}
          clientInfo={props.clientsInfo[details.authorizationDetails.clientId]}
          details={details}
          addresses={details.authDetails?.addresses}
          authTrips={details.authDetails?.authTrips}
          id={props.match.params.id}
          vendors={props.vendors}
          resetSurveyApiCall={resetSurveyApiCall}
          enumerations={props.enumerations}
          emailTemplates={props.templates ? props.templates.emailTemplates : []}
          fileTasks={props.fileTasks}
          createFileTask={props.createFileTask}
          showToast={props.showToast}
          updateTask={props.updateTask}
          postAuthorizationComment={props.postAuthorizationComment}
          getTaskComments={props.getTaskComments}
          history={props.history}

        />
      )}
      {(props.isLoading || props.isFamilyLoading || !props.enumerations.isLoaded || (details && details.authorizationDetails && !props.clientsInfo[details.authorizationDetails.clientId])) && <FullscreenSpinner />}
    </Box>
  );
};

AuthorizationDetailsView.propTypes = {
  classes: PropTypes.object.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapStateToProps = state => {
  const { authorizationDetails, isLoading, vendors, currentAuthId } = state.authorizations;
  const { unmappedClients, clientsInfo } = state.clients;
  const enumerations = state.enumerations;
  const templates = state.templates;

  return {
    authorizationDetails,
    unmappedClients,
    isLoading,
    vendors,
    enumerations,
    templates,
    clientsInfo,
    fileTasks: authorizationDetails[currentAuthId]?.fileTasks ?? []
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getGlobalInfo,
    getVendors,
    setPageTitle,
    showToast,
    setAuthId,
    setLoadingComplete,
    getCommentsAndNotes,
    getAuthClientPoliciesListByClient,
    updateAuthorizationSummary,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getAuthorizationComments,
    getInternalUsers,
    getTemporaryLivingAssignments,
    getSurveyQuestionResponsesByAuth,
    getEmailTemplateSummaries,
    getClientDetails,
    setClientId,
    getTasksByFileId,
    createFileTask,
    updateTask,
    postAuthorizationComment,
    getTaskComments
  })
)(AuthorizationDetailsView);
